module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 10.5\"><path id=\"パス_2138\" data-name=\"パス 2138\" d=\"M1429.749,1443.25h-3.563a.844.844,0,0,1-.844-.844v-8.156h-2.25v3.656a.843.843,0,0,1-.843.844h-3.282a.375.375,0,0,1-.375-.375v-.75a.375.375,0,0,1,.375-.375h2.625v-3.656a.844.844,0,0,1,.844-.844H1426a.843.843,0,0,1,.843.844v8.156h2.25v-3.656a.844.844,0,0,1,.844-.844h3.281a.375.375,0,0,1,.375.375v.75a.375.375,0,0,1-.375.375h-2.625v3.656A.843.843,0,0,1,1429.749,1443.25Z\" transform=\"translate(-1418.592 -1432.75)\" fill=\"#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/generate.svg
// module id = j6f3
// module chunks = 1